import { getLocale } from "../runtime";

const sv_carttitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Min varukorg`
};

const carttitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_carttitle(inputs)
	return "cartTitle";
};

export { carttitle as "cartTitle" };